export default "https://cdn-static.gokick.com/assets/bd7d2df9c3fbba7be4a416b625ad3f88793f3763/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";